import firebase from "firebase/app";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAzQukzHlNnUNocJCxkDNTroWn1GPn_eZQ",
  authDomain: "goyohan-business.firebaseapp.com",
  projectId: "goyohan-business",
  storageBucket: "goyohan-business.appspot.com",
  messagingSenderId: "159537685174",
  appId: "1:159537685174:web:aec87c3eb2931ae0fcfc17",
  measurementId: "G-JDKZEGET58",
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

export { auth };
